export default {
  header: {
    display: 'flex',
    flexDirection: 'row',
    paddingRight: 32,
    paddingLeft: 32,
    alignItems: 'center',
  },

  tableContainer: {
    display: 'flex',
    width: '100%',
    flex: 1,
    marginTop: 16,
    marginBottom: 32,
  },

  table: {
    backgroundColor: 'white',
    marginLeft: 32,
    marginRight: 32,
    width: '100%',
    borderRadius: 14,
    padding: 14,
  },

  containerMessage: {
    background: '#fff',
    margin: '32px auto',
    fontSize: '18px',
    color: '#333',
    borderRadius: '12px',
    padding: '28px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    lineHeight: '1.6',
    maxWidth: '900px',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
  },

  icon: {
    fontSize: '28px',
    marginRight: '12px',
  },

  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#d9534f',
  },

  description: {
    fontSize: '18px',
    color: '#555',
    marginBottom: '16px',
  },

  highlight: {
    color: '#000',
    fontWeight: 'bold',
  },

  divider: {
    height: '1px',
    background: '#eee',
    margin: '20px 0',
  },

  boxList: {
    background: '#f9fafc',
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '16px',
    marginTop: '12px',
    fontSize: '18px',
    color: '#444',
    whiteSpace: 'pre-line',
    lineHeight: '1.5',
  },
};
